var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import MuiButton from '@mui/material/Button';
export var ButtonBase = styled(MuiButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: none;\n  padding: 0 1rem;\n  font-size: 1rem;\n  text-transform: none;\n  white-space: nowrap;\n  transition: all ease-in-out 0.2s;\n\n  &,\n  &.MuiButton-root.Mui-disabled {\n    color: ", ";\n  }\n\n  &.MuiButton-root.Mui-disabled {\n    opacity: 0.65;\n  }\n\n  .MuiButton-label {\n    font-family: ", ";\n  }\n"], ["\n  transition: none;\n  padding: 0 1rem;\n  font-size: 1rem;\n  text-transform: none;\n  white-space: nowrap;\n  transition: all ease-in-out 0.2s;\n\n  &,\n  &.MuiButton-root.Mui-disabled {\n    color: ", ";\n  }\n\n  &.MuiButton-root.Mui-disabled {\n    opacity: 0.65;\n  }\n\n  .MuiButton-label {\n    font-family: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.textLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.default;
});
var templateObject_1;
